import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';

@customElement('solar-page-tender-text')
export class SolarPageTenderText extends LitElement {

	static styles = css`
		.page-container {
			display: flex;
			margin: var(--specsheet-medium-gap) var(--specsheet-large-gap);

		}

		.image {
			width: 35%;
		}

		.tenderText {
			font: var(--font-specsheet-light);
			width: 65%;
			padding-right: 50px;
		}

		@media print {
			.page-container {
				display: flex;
				margin: var(--specsheet-medium-gap) 0;

			}

			.image {
				width: 30%;
			}

			.tenderText {
				font: var(--font-specsheet-light);
				width: 70%;
				padding-right: 50px;
			}
		}
	`;

	render() {
		return html`

			<div class="page-container">
				<div class="image">
					<span>img</span>
				</div>

				<div class="tenderText">
					<solar-tender-text></solar-tender-text>
				</div>
			</div>

		`;
	}
}
